function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, forwardRef } from "react";
import PropTypes from "prop-types";
import { HtmlRenderer, JsonRenderer } from "./renderers";
import { ErrorBoundary } from "../utilities/ErrorBoundary";
import { SkeletonLoader } from "../utilities/SkeletonLoader";
import { useTrackMboxWithSatellite } from "../../providers/satellite";
import useCacheEntry from "../../utils/lpe-cache/hooks/useCacheEntry";
var LPEHOC = /*#__PURE__*/ forwardRef(function LPEHOC(props, ref) {
    // Extract incoming parameters from props
    var config = props.config, _props_children = props.children, children = _props_children === void 0 ? null : _props_children, _props_foocMask = props.foocMask, foocMask = _props_foocMask === void 0 ? true : _props_foocMask;
    // Memoize the original children to prevent re-renders of wrapped components
    var fallback = useMemo(function() {
        return children;
    }, [
        children
    ]);
    var augmentedConfig = useMemo(function() {
        // if there is a lazy cache entry, try to fulfill it asap.
        return _extends({
            immediate: true
        }, config);
    }, [
        config
    ]);
    // Subscription to LPECache entry
    var _ref = useCacheEntry(augmentedConfig) || {}, _ref_state = _ref.state, state = _ref_state === void 0 ? {} : _ref_state, _ref_payload = _ref.payload, payload = _ref_payload === void 0 ? {} : _ref_payload;
    // Analytics hook to add this ABTest content to smetrics
    useTrackMboxWithSatellite(payload);
    // Get type from payload
    var tmp = payload.options, _ref1 = _sliced_to_array(tmp === void 0 ? [] : tmp, 1), tmp1 = _ref1[0], _ref2 = tmp1 === void 0 ? {} : tmp1, type = _ref2.type, content = _ref2.content;
    // Render size-aware placeholder while cache is in fetching state
    if (foocMask === true && state.done === false) {
        return /*#__PURE__*/ _jsx(SkeletonLoader, {
            ref: ref,
            children: fallback
        });
    }
    // If returned payload contains a type, utilize special renderer
    if (state.status === "fetched" && [
        "html",
        "json"
    ].indexOf(type) > -1) {
        var _config;
        return /*#__PURE__*/ _jsxs(ErrorBoundary, {
            name: (_config = config) == null ? void 0 : _config.name,
            fallback: fallback,
            children: [
                type === "html" && /*#__PURE__*/ _jsx(HtmlRenderer, _extends({}, props, {
                    content: content,
                    ref: ref
                })),
                type === "json" && /*#__PURE__*/ _jsx(JsonRenderer, _extends({}, props, {
                    content: content,
                    ref: ref
                }))
            ]
        });
    }
    // Render original children
    return fallback;
});
LPEHOC.propTypes = {
    name: PropTypes.string,
    parameters: PropTypes.object,
    overrideResponseProps: PropTypes.object
};
LPEHOC.defaultProps = {
    name: undefined,
    parameters: undefined,
    overrideResponseProps: undefined
};
export default LPEHOC;

//# sourceMappingURL=LPEHOC.js.map